/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Notsubscribedbody2Inputs */

const id_notifications_notsubscribedbody2 = /** @type {(inputs: Notifications_Notsubscribedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunci API Anda tidak berlangganan notifikasi push. Gunakan tab "Pengaturan & Berlangganan" untuk berlangganan terlebih dahulu.`)
};

const ms_notifications_notsubscribedbody2 = /** @type {(inputs: Notifications_Notsubscribedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunci API anda tidak dilanggan pada pemberitahuan push. Gunakan tab "Persediaan & Langgan" untuk melanggan terlebih dahulu.`)
};

const da_notifications_notsubscribedbody2 = /** @type {(inputs: Notifications_Notsubscribedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Din API-nøgle er ikke abonneret på push-notifikationer. Brug fanen "Opsæt & Abonner" for at abonnere først.`)
};

const de_notifications_notsubscribedbody2 = /** @type {(inputs: Notifications_Notsubscribedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihr API-Schlüssel ist nicht für Push-Benachrichtigungen abonniert. Verwenden Sie zuerst die Registerkarte "Einrichten & Abonnieren", um ein Abonnement abzuschließen.`)
};

const en_us2_notifications_notsubscribedbody2 = /** @type {(inputs: Notifications_Notsubscribedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your API key is not subscribed to push notifications. Use the "Setup & Subscribe" tab to subscribe first.`)
};

const es_es2_notifications_notsubscribedbody2 = /** @type {(inputs: Notifications_Notsubscribedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu clave de API no está suscrita a las notificaciones push. Usa la pestaña "Configurar y suscribirse" para suscribirte primero.`)
};

const es_mx2_notifications_notsubscribedbody2 = /** @type {(inputs: Notifications_Notsubscribedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu clave de API no está suscrita a las notificaciones push. Usa la pestaña "Configurar y suscribirse" para suscribirte primero.`)
};

const fil_notifications_notsubscribedbody2 = /** @type {(inputs: Notifications_Notsubscribedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang iyong API key ay hindi naka-subscribe sa push notifications. Gamitin ang tab na "Setup & Subscribe" para mag-subscribe muna.`)
};

const fr_notifications_notsubscribedbody2 = /** @type {(inputs: Notifications_Notsubscribedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre clé API n'est pas abonnée aux notifications push. Utilisez l'onglet « Configuration et abonnement » pour vous abonner d'abord.`)
};

const it_notifications_notsubscribedbody2 = /** @type {(inputs: Notifications_Notsubscribedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua chiave API non è iscritta alle notifiche push. Usa la scheda "Setup e iscrizione" per iscriverti prima.`)
};

const hu_notifications_notsubscribedbody2 = /** @type {(inputs: Notifications_Notsubscribedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API kulcsod nincs feliratkozva push értesítésekre. Használd a "Beállítás és feliratkozás" fület az előzetes feliratkozáshoz.`)
};

const nl_notifications_notsubscribedbody2 = /** @type {(inputs: Notifications_Notsubscribedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je API-sleutel is niet geabonneerd op pushmeldingen. Gebruik het tabblad "Instellen en abonneren" om je eerst te abonneren.`)
};

const no_notifications_notsubscribedbody2 = /** @type {(inputs: Notifications_Notsubscribedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-nøkkelen din er ikke abonnert på push-varsler. Bruk fanen "Konfigurer og abonner" for å abonnere først.`)
};

const pl_notifications_notsubscribedbody2 = /** @type {(inputs: Notifications_Notsubscribedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twój klucz API nie jest subskrybowany do powiadomień push. Użyj zakładki "Konfiguruj i subskrybuj", aby najpierw zasubskrybować.`)
};

const pt_br2_notifications_notsubscribedbody2 = /** @type {(inputs: Notifications_Notsubscribedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua chave API não está inscrita para notificações push. Use a guia "Configurar e assinar" para se inscrever primeiro.`)
};

const pt_notifications_notsubscribedbody2 = /** @type {(inputs: Notifications_Notsubscribedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A sua chave de API não está subscrita a notificações push. Use o separador "Configurar & Subscrever" para subscrever primeiro.`)
};

const ro_notifications_notsubscribedbody2 = /** @type {(inputs: Notifications_Notsubscribedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cheia ta API nu este abonată la notificări push. Folosește fila "Configurare și Abonare" pentru a te abona mai întâi.`)
};

const fi_notifications_notsubscribedbody2 = /** @type {(inputs: Notifications_Notsubscribedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-avaimesi ei ole tilannut push-ilmoituksia. Käytä "Asetukset ja tilaa" -välilehteä tilataksesi ensin.`)
};

const sv_notifications_notsubscribedbody2 = /** @type {(inputs: Notifications_Notsubscribedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Din API-nyckel prenumererar inte på push-notiser. Använd fliken "Konfigurera & prenumerera" för att prenumerera först.`)
};

const vi_notifications_notsubscribedbody2 = /** @type {(inputs: Notifications_Notsubscribedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khóa API của bạn chưa đăng ký thông báo đẩy. Sử dụng tab "Thiết lập & Đăng ký" để đăng ký trước.`)
};

const tr_notifications_notsubscribedbody2 = /** @type {(inputs: Notifications_Notsubscribedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API anahtarınız push bildirimlerine abone değil. Önce abone olmak için "Kurulum ve Abone Ol" sekmesini kullanın.`)
};

const cs_notifications_notsubscribedbody2 = /** @type {(inputs: Notifications_Notsubscribedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Váš API klíč není přihlášen k odběru push oznámení. Nejprve použijte záložku "Nastavení a přihlášení".`)
};

const bg_notifications_notsubscribedbody2 = /** @type {(inputs: Notifications_Notsubscribedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вашият API ключ не е абониран за push известия. Използвайте раздела "Настройка и абониране", за да се абонирате първо.`)
};

const ru_notifications_notsubscribedbody2 = /** @type {(inputs: Notifications_Notsubscribedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш API-ключ не подписан на push-уведомления. Используйте вкладку «Настройка и подписка», чтобы сначала подписаться.`)
};

const uk_notifications_notsubscribedbody2 = /** @type {(inputs: Notifications_Notsubscribedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш API-ключ не підписаний на push-сповіщення. Спочатку скористайтеся вкладкою «Налаштувати та підписатися».`)
};

const ar_notifications_notsubscribedbody2 = /** @type {(inputs: Notifications_Notsubscribedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مفتاح API الخاص بك غير مشترك في الإشعارات الفورية. استخدم علامة التبويب "الإعداد والاشتراك" للاشتراك أولاً.`)
};

const hi_notifications_notsubscribedbody2 = /** @type {(inputs: Notifications_Notsubscribedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपकी API कुंजी पुश सूचनाओं के लिए सब्सक्राइब नहीं है।`)
};

const th_notifications_notsubscribedbody2 = /** @type {(inputs: Notifications_Notsubscribedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คีย์ API ของคุณยังไม่ได้สมัครรับการแจ้งเตือนแบบพุช ใช้แท็บ "ตั้งค่าและสมัครรับ" เพื่อสมัครก่อน`)
};

const ja_notifications_notsubscribedbody2 = /** @type {(inputs: Notifications_Notsubscribedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API キーはプッシュ通知に購読していません。「設定と購読」タブを使用して先に購読してください。`)
};

const zh_cn2_notifications_notsubscribedbody2 = /** @type {(inputs: Notifications_Notsubscribedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的API密钥未订阅推送通知。请先使用“设置与订阅”选项卡进行订阅。`)
};

const zh_hant1_notifications_notsubscribedbody2 = /** @type {(inputs: Notifications_Notsubscribedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的API金鑰未訂閱推播通知。請先使用「設定與訂閱」索引標籤進行訂閱。`)
};

const ko_notifications_notsubscribedbody2 = /** @type {(inputs: Notifications_Notsubscribedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API 키가 푸시 알림에 구독되어 있지 않습니다. 먼저 "설정 및 구독" 탭을 사용하여 구독하세요.`)
};

/**
* | output |
* | --- |
* | "Your API key is not subscribed to push notifications. Use the \"Setup & Subscribe\" tab to subscribe first." |
*
* @param {Notifications_Notsubscribedbody2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_notsubscribedbody2 = /** @type {((inputs?: Notifications_Notsubscribedbody2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Notsubscribedbody2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_notsubscribedbody2(inputs)
	if (locale === "ms") return ms_notifications_notsubscribedbody2(inputs)
	if (locale === "da") return da_notifications_notsubscribedbody2(inputs)
	if (locale === "de") return de_notifications_notsubscribedbody2(inputs)
	if (locale === "en-US") return en_us2_notifications_notsubscribedbody2(inputs)
	if (locale === "es-ES") return es_es2_notifications_notsubscribedbody2(inputs)
	if (locale === "es-MX") return es_mx2_notifications_notsubscribedbody2(inputs)
	if (locale === "fil") return fil_notifications_notsubscribedbody2(inputs)
	if (locale === "fr") return fr_notifications_notsubscribedbody2(inputs)
	if (locale === "it") return it_notifications_notsubscribedbody2(inputs)
	if (locale === "hu") return hu_notifications_notsubscribedbody2(inputs)
	if (locale === "nl") return nl_notifications_notsubscribedbody2(inputs)
	if (locale === "no") return no_notifications_notsubscribedbody2(inputs)
	if (locale === "pl") return pl_notifications_notsubscribedbody2(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_notsubscribedbody2(inputs)
	if (locale === "pt") return pt_notifications_notsubscribedbody2(inputs)
	if (locale === "ro") return ro_notifications_notsubscribedbody2(inputs)
	if (locale === "fi") return fi_notifications_notsubscribedbody2(inputs)
	if (locale === "sv") return sv_notifications_notsubscribedbody2(inputs)
	if (locale === "vi") return vi_notifications_notsubscribedbody2(inputs)
	if (locale === "tr") return tr_notifications_notsubscribedbody2(inputs)
	if (locale === "cs") return cs_notifications_notsubscribedbody2(inputs)
	if (locale === "bg") return bg_notifications_notsubscribedbody2(inputs)
	if (locale === "ru") return ru_notifications_notsubscribedbody2(inputs)
	if (locale === "uk") return uk_notifications_notsubscribedbody2(inputs)
	if (locale === "ar") return ar_notifications_notsubscribedbody2(inputs)
	if (locale === "hi") return hi_notifications_notsubscribedbody2(inputs)
	if (locale === "th") return th_notifications_notsubscribedbody2(inputs)
	if (locale === "ja") return ja_notifications_notsubscribedbody2(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_notsubscribedbody2(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_notsubscribedbody2(inputs)
	return ko_notifications_notsubscribedbody2(inputs)
});
export { notifications_notsubscribedbody2 as "notifications.notSubscribedBody" }